// one separable pass with a running sum: O(pixels) whatever the radius; edges repeat the border pixel, alpha stays opaque
function blurAxis(
  src: Uint8ClampedArray,
  dst: Uint8ClampedArray,
  width: number,
  height: number,
  radius: number,
  horizontal: boolean
) {
  const lines = horizontal ? height : width
  const length = horizontal ? width : height
  const step = horizontal ? 4 : width * 4
  const lineStep = horizontal ? width * 4 : 4
  const window = radius * 2 + 1
  const clamp = (i: number) => Math.min(length - 1, Math.max(0, i))
  for (let line = 0; line < lines; line++) {
    const base = line * lineStep
    for (let channel = 0; channel < 3; channel++) {
      let sum = 0
      for (let i = -radius; i <= radius; i++) sum += src[base + clamp(i) * step + channel]
      for (let i = 0; i < length; i++) {
        dst[base + i * step + channel] = sum / window
        sum += src[base + clamp(i + radius + 1) * step + channel] - src[base + clamp(i - radius) * step + channel]
      }
    }
    for (let i = 0; i < length; i++) dst[base + i * step + 3] = 255
  }
}

// Returns a box-blurred copy of `source`. The OCR crop goes through it when Tesseract cannot read the raw pixels:
// a photo of a screen resolves the pixel grid, which the engine takes for rows of tiny glyphs.
export function blurCanvas(source: HTMLCanvasElement, radius: number): HTMLCanvasElement {
  const sourceContext = source.getContext('2d')
  const out = document.createElement('canvas')
  const outContext = out.getContext('2d')
  if (!sourceContext || !outContext) return source
  out.width = source.width
  out.height = source.height
  const image = sourceContext.getImageData(0, 0, source.width, source.height)
  const pass = new Uint8ClampedArray(image.data.length)
  blurAxis(image.data, pass, image.width, image.height, radius, true)
  blurAxis(pass, image.data, image.width, image.height, radius, false)
  outContext.putImageData(image, 0, 0)
  return out
}
